module.exports = "<ul class=\"questionlist\">\r\n  <li ng-repeat=\"q in model.form[current.step].questions\">\r\n  \t<input type=\"checkbox\" id=\"cbl{{$id}}{{$index}}\" ng-model=\"q.checked\" />\r\n    <label for=\"cbl{{$id}}{{$index}}\" ng-bind=\"q.label\"></label>\r\n  </li>\r\n</ul>"


/*****************
 ** WEBPACK FOOTER
 ** ./assets_src/html/registration.cbl.html
 ** module id = 13
 ** module chunks = 0
 **/